import { Component, OnInit } from '@angular/core';
import { AppInsights } from 'applicationinsights-js';
import { browserInfo } from 'src/util/browser';

@Component({
  selector: 'fl-browser-notice',
  templateUrl: './browser-notice.component.html',
  styleUrls: ['./browser-notice.component.scss'],
})
export class BrowserNoticeComponent implements OnInit {
  public browserInfo = browserInfo;

  public ngOnInit() {
    if (!browserInfo.isSupported) {
      // tslint:disable-next-line: no-console
      console.warn('Unsupported browser', browserInfo);
      AppInsights.trackEvent('UnsupportedBrowser', {
        browserInfo: JSON.stringify(browserInfo),
      });
    }
  }
}
